import { Link } from '@liveauctioneers/hammer-ui-core/link';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { MouseEvent, useCallback } from 'react';

import { Event } from '@/types/Event';

import { buildUrl, isMobile } from './helpers';

type Props = {
    className?: string;
    event: Event;
    keyName: string;
    label: string;
    onClick?: (linkType: string) => void;
    target?: string;
    testid?: string;
};

export const AddToCalendarLink = ({ className, event, keyName, label, onClick, target, testid }: Props) => {
    const url = buildUrl(event, keyName);

    const handleClick = useCallback(
        (e: MouseEvent<HTMLAnchorElement>) => {
            e.preventDefault();
            if (!isMobile() && url.startsWith('BEGIN')) {
                const filename = 'download.ics';
                const blob = new Blob([url], {
                    type: 'text/calendar;charset=utf-8',
                });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
                window.open(url, '_blank');
            }
            onClick?.(keyName);
        },
        [keyName, onClick, url]
    );

    return (
        <Link
            aria-label="Add to calendar"
            className={cn(className)}
            data-testid={testid}
            href={url}
            onClick={handleClick}
            target={target}
        >
            {label}
        </Link>
    );
};
